import { render, staticRenderFns } from "./EditHistory.vue?vue&type=template&id=1b0a7e52"
import script from "./EditHistory.vue?vue&type=script&lang=js"
export * from "./EditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports